import { IControl, IField } from 'app/services/api5-service/api.interface';
import { map, Observable } from 'rxjs';

import { matchMediaBreakpointDown$ } from 'common/media';

import { ISPFieldConfig, ISPFieldTypeWithControl } from '../model';

/**
 * Check if field should be fullWidth
 *
 * @param field - field metadata
 * @param control - control meta
 */
export function isFullWidth(field: IField, control?: IControl): boolean {
  return (
    field.$fullwidth === 'yes' ||
    control?.$fullwidth === 'yes' ||
    Boolean(field.frame?.length)
  );
}

/**
 * Is field fullwidth stream
 *
 * @TODO using in frame, group, skeleton, switcher, switcher-select,
 * textarea, textdata, texteditor, tree
 * @param field
 * @param config
 */
export function isFullWidth$(
  field: IField,
  config: ISPFieldConfig<ISPFieldTypeWithControl>,
): Observable<boolean> {
  return matchMediaBreakpointDown$('sm').pipe(
    map(
      isLessSm => isLessSm || isFullWidth(field, config.props.originalControl),
    ),
  );
}
